import React from 'react';
import { makeStyles, createStyles, Theme, Divider, FormControlLabel, Checkbox } from '@material-ui/core';
import Utils from '../../utils';
import { useDispatch, useSelector } from 'react-redux';
import { getOperationCode } from '../../screens/admin/action';
import { ReducersModel } from '../../model';
import IndeterminateCheckBoxOutlinedIcon from '@material-ui/icons/IndeterminateCheckBoxOutlined';
import { useTranslation } from 'react-i18next';

const styles = makeStyles((theme: Theme) =>
    createStyles({
        mainContainer: {
            minWidth: '210px',
        },
        title: {
            padding: '0 16px 8px 16px',
            textAlign: 'left',
            font: 'normal normal normal 14px/21px Roboto',
            letterSpacing: '0.08px',
            color: '#515151',
            opacity: 1,
        },
        subTitle: {
            padding: '8px 16px',
            textAlign: 'left',
            font: 'normal normal normal 14px/21px Roboto',
            letterSpacing: '0.08px',
            color: '#515151',
            opacity: 1,
        },
        filtersBox: {
            padding: '8px 16px',
            textAlign: 'left',
            font: 'normal normal normal 14px/21px Roboto',
            letterSpacing: '0.08px',
            color: '#515151',
            opacity: 1,
            display: 'flex',
            flexDirection: 'column',
            '& .MuiTypography-root': {
                textAlign: 'left',
                font: 'normal normal normal 12px/21px Roboto',
                letterSpacing: '0.07px',
                color: '#868686',
                opacity: 1,
            },
            '& .MuiCheckbox-root': {
                padding: '2px 7px',
            },
            '& .MuiFormGroup-root': { flexDirection: 'row!important' },
        },
        statusContainer: {
            display: 'flex',
            alignItems: 'center',
        },
        status: {
            marginRight: '40px',
            textAlign: 'left',
            font: 'normal normal normal 14px/21px Roboto',
            letterSpacing: '0.08px',
            color: '#515151',
            opacity: 1,
        },
        indeterminateColor: {
            color: '#1E88E5',
        },
        disabledCheck: {
            '& .MuiTypography-body1': {
                fontStyle: 'italic',
                color: '#868686',
            },
        },
        naturalCheck: {
            '& .MuiTypography-root': {
                color: '#515151',
            },
        },
    }),
);

export default function OperationCodesFilter({ factories, skills }: any) {
    const classes = styles();
    const { filterStatus, filterFactoryIds, filterSkillIds } = useSelector(
        (state: ReducersModel) => state.operationCodeReducer,
    );
    const { t } = useTranslation();
    const dispatch = useDispatch();

    return (
        <div className={classes.mainContainer}>
            <div className={classes.title}>{t('Filterby')}</div>
            <Divider />
            <div>
                <div className={classes.subTitle}>{t('Status')}</div>
                <div className={classes.filtersBox}>
                    <FormControlLabel
                        value={'true'}
                        className={classes.naturalCheck}
                        control={
                            <Checkbox
                                color={'primary'}
                                checked={filterStatus.includes('true')}
                                name="shift"
                                onChange={(event: any) => {
                                    const target = event.target;
                                    if (target.checked) {
                                        if (!filterStatus.includes(target.value)) {
                                            let newArray = [...filterStatus];
                                            newArray.push(target.value);
                                            dispatch({
                                                type: Utils.ActionName.UPDATE_OPERRATION_CODE,
                                                payload: {
                                                    filterStatus: newArray,
                                                },
                                            });
                                            dispatch(getOperationCode());
                                        }
                                    } else {
                                        if (filterStatus.includes(target.value)) {
                                            const index = filterStatus.indexOf(target.value);
                                            let newArray = [...filterStatus];
                                            if (index > -1) {
                                                newArray.splice(index, 1);
                                            }
                                            dispatch({
                                                type: Utils.ActionName.UPDATE_OPERRATION_CODE,
                                                payload: {
                                                    filterStatus: newArray,
                                                },
                                            });
                                            dispatch(getOperationCode());
                                        }
                                    }
                                }}
                            />
                        }
                        label={t('Active')}
                    />
                    <FormControlLabel
                        value={'false'}
                        className={classes.naturalCheck}
                        control={
                            <Checkbox
                                color={'primary'}
                                name="shift"
                                checked={filterStatus.includes('false')}
                                onChange={(event: any) => {
                                    const target = event.target;
                                    if (target.checked) {
                                        if (!filterStatus.includes(target.value)) {
                                            let newArray = [...filterStatus];
                                            newArray.push(target.value);
                                            dispatch({
                                                type: Utils.ActionName.UPDATE_OPERRATION_CODE,
                                                payload: {
                                                    filterStatus: newArray,
                                                },
                                            });
                                            dispatch(getOperationCode());
                                        }
                                    } else {
                                        if (filterStatus.includes(target.value)) {
                                            const index = filterStatus.indexOf(target.value);
                                            let newArray = [...filterStatus];
                                            if (index > -1) {
                                                newArray.splice(index, 1);
                                            }
                                            dispatch({
                                                type: Utils.ActionName.UPDATE_OPERRATION_CODE,
                                                payload: {
                                                    filterStatus: newArray,
                                                },
                                            });
                                            dispatch(getOperationCode());
                                        }
                                    }
                                }}
                            />
                        }
                        label={t('Inactive')}
                    />
                </div>
            </div>

            <Divider />
            <div>
                <div className={classes.subTitle}>{t('Createdbyfactories')}</div>
                <div className={classes.filtersBox}>
                    <div>
                        {factories && factories.length > 2 && (
                            <FormControlLabel
                                className={classes.naturalCheck}
                                control={
                                    <Checkbox
                                        color={'primary'}
                                        checked={factories?.length === filterFactoryIds.length}
                                        indeterminate={
                                            filterFactoryIds.length !== 0 &&
                                            factories?.length !== filterFactoryIds.length
                                        }
                                        indeterminateIcon={
                                            <IndeterminateCheckBoxOutlinedIcon className={classes.indeterminateColor} />
                                        }
                                        inputProps={{
                                            'aria-label': 'decorative checkbox',
                                        }}
                                        onChange={(event: any) => {
                                            const target = event.target;
                                            if (target.checked) {
                                                let newArray = factories.map((a: any) => `${a.id}`);
                                                dispatch({
                                                    type: Utils.ActionName.UPDATE_OPERRATION_CODE,
                                                    payload: {
                                                        filterFactoryIds: newArray,
                                                    },
                                                });
                                                dispatch(getOperationCode());
                                            } else {
                                                dispatch({
                                                    type: Utils.ActionName.UPDATE_OPERRATION_CODE,
                                                    payload: {
                                                        filterFactoryIds: [],
                                                    },
                                                });
                                                dispatch(getOperationCode());
                                            }
                                        }}
                                    />
                                }
                                label={<div>{t('All')}</div>}
                            />
                        )}
                    </div>
                    {factories && factories.length > 0 ? (
                        factories.map((factory: any, index: number) => {
                            return (
                                <FormControlLabel
                                    key={index}
                                    value={factory.id}
                                    className={factory.isActive ? classes.naturalCheck : classes.disabledCheck}
                                    control={
                                        <Checkbox
                                            color={'primary'}
                                            name="factory"
                                            checked={filterFactoryIds.includes(`${factory.id}`)}
                                            onChange={(event: any) => {
                                                const target = event.target;
                                                if (target.checked) {
                                                    if (!filterFactoryIds.includes(target.value)) {
                                                        let newArray = [...filterFactoryIds];

                                                        newArray.push(target.value);
                                                        dispatch({
                                                            type: Utils.ActionName.UPDATE_OPERRATION_CODE,
                                                            payload: {
                                                                filterFactoryIds: newArray,
                                                            },
                                                        });
                                                        dispatch(getOperationCode());
                                                    }
                                                } else {
                                                    if (filterFactoryIds.includes(target.value)) {
                                                        const index = filterFactoryIds.indexOf(target.value);
                                                        let newArray = [...filterFactoryIds];
                                                        if (index > -1) {
                                                            newArray.splice(index, 1);
                                                        }
                                                        dispatch({
                                                            type: Utils.ActionName.UPDATE_OPERRATION_CODE,
                                                            payload: {
                                                                filterFactoryIds: newArray,
                                                            },
                                                        });
                                                        dispatch(getOperationCode());
                                                    }
                                                }
                                            }}
                                        />
                                    }
                                    label={factory.factory}
                                />
                            );
                        })
                    ) : (
                        <div>{t('NoRecordfound')}</div>
                    )}
                </div>
            </div>

            <Divider />
            <div>
                <div className={classes.subTitle}>{t('SkillType')}</div>
                <div className={classes.filtersBox}>
                    <div>
                        {skills && skills.length > 2 && (
                            <FormControlLabel
                                className={classes.naturalCheck}
                                control={
                                    <Checkbox
                                        color={'primary'}
                                        checked={skills?.length === filterSkillIds.length}
                                        indeterminate={
                                            filterSkillIds.length !== 0 && skills?.length !== filterSkillIds.length
                                        }
                                        indeterminateIcon={
                                            <IndeterminateCheckBoxOutlinedIcon className={classes.indeterminateColor} />
                                        }
                                        inputProps={{
                                            'aria-label': 'decorative checkbox',
                                        }}
                                        onChange={(event: any) => {
                                            const target = event.target;
                                            if (target.checked) {
                                                let newArray = skills.map((a: any) => `${a.id}`);
                                                dispatch({
                                                    type: Utils.ActionName.UPDATE_OPERRATION_CODE,
                                                    payload: {
                                                        filterSkillIds: newArray,
                                                    },
                                                });
                                                dispatch(getOperationCode());
                                            } else {
                                                dispatch({
                                                    type: Utils.ActionName.UPDATE_OPERRATION_CODE,
                                                    payload: {
                                                        filterSkillIds: [],
                                                    },
                                                });
                                                dispatch(getOperationCode());
                                            }
                                        }}
                                    />
                                }
                                label={<div>{t('All')}</div>}
                            />
                        )}
                    </div>
                    {skills && skills.length > 0 ? (
                        skills.map((skill: any, index: number) => {
                            return (
                                <FormControlLabel
                                    key={index}
                                    value={skill.id}
                                    className={classes.naturalCheck}
                                    control={
                                        <Checkbox
                                            color={'primary'}
                                            name="skill"
                                            checked={filterSkillIds.includes(`${skill.id}`)}
                                            onChange={(event: any) => {
                                                const target = event.target;
                                                if (target.checked) {
                                                    if (!filterSkillIds.includes(target.value)) {
                                                        let newArray = [...filterSkillIds];

                                                        newArray.push(target.value);
                                                        dispatch({
                                                            type: Utils.ActionName.UPDATE_OPERRATION_CODE,
                                                            payload: {
                                                                filterSkillIds: newArray,
                                                            },
                                                        });
                                                        dispatch(getOperationCode());
                                                    }
                                                } else {
                                                    if (filterSkillIds.includes(target.value)) {
                                                        const index = filterSkillIds.indexOf(target.value);
                                                        let newArray = [...filterSkillIds];
                                                        if (index > -1) {
                                                            newArray.splice(index, 1);
                                                        }
                                                        dispatch({
                                                            type: Utils.ActionName.UPDATE_OPERRATION_CODE,
                                                            payload: {
                                                                filterSkillIds: newArray,
                                                            },
                                                        });
                                                        dispatch(getOperationCode());
                                                    }
                                                }
                                            }}
                                        />
                                    }
                                    label={skill.displayName}
                                />
                            );
                        })
                    ) : (
                        <div>{t('NoRecordfound')}</div>
                    )}
                </div>
            </div>
        </div>
    );
}
